import {
  App,
  areFENummerEqual,
  FremdVNVorvertrag,
  VnWechselAngaben,
} from '@ps20-frontend/frontend-models';
import { AddVertragToAngebote, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { IAppState } from '@ps20-frontend/apps/vwg-store';

export const vnWechselAngabenReducer = function (
  sectionState: VnWechselAngaben = null,
  action: AnyAction,
  state: IAppState,
): VnWechselAngaben {
  switch (action.type) {
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      const actionPayload: AddVertragToAngebote = action.payload;
      if (
        actionPayload.appId === App.VWG &&
        actionPayload.angebotsId === state.angebotsId &&
        actionPayload.vnWechselAngaben
      ) {
        return { ...actionPayload.vnWechselAngaben };
      }
      return sectionState;
    }
    case GlobalActions.VN_WECHSEL_GRUND_CHANGED: {
      const payload: FremdVNVorvertrag = action.payload;
      if (payload.vnWechselGrund.every(value => value.appId === App.VWG)) {
        const found: FremdVNVorvertrag = sectionState.angabenListe
          ?.reduce((acc, angabe) => acc.concat(angabe.fremdVNVorvertraege), [])
          .find(fremdVNVorvertrag =>
            areFENummerEqual(fremdVNVorvertrag.vorvertragsnummer, payload.vorvertragsnummer),
          );
        if (found) {
          found.vnWechselGrund = payload.vnWechselGrund;
        }
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
